export default __webpack_public_path__ + "static/containers-do-a34d012e35ec39dcae307e9d0853894c6f5f6d7c285f3d0e2c73e1f87a21f1f8.png";